import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import PortfoliosDataGrid from '@/features/portfolioHierarchy/components/PortfoliosDataGrid'
import { PortfolioHierarchyRouteInformation } from '@/features/portfolioHierarchy/constants'
import { usePortfolioHierarchyLayout } from '@/features/portfolioHierarchy/PortfolioHierarchyLayout'

function PortfoliosIndex() {
  const { t } = useTranslation()
  const { setPageConfig } = usePortfolioHierarchyLayout()

  useEffect(() => {
    setPageConfig({
      title: t('component.page_header.portfolios'),
      breadcrumbs: [
        {
          text: t('component.page_header.portfolio_hierarchy'),
          to: PortfolioHierarchyRouteInformation.INDEX.navigationPath,
        },
      ],
      pageTag: 'portfolios',
      activeTab: PortfolioHierarchyRouteInformation.PORTFOLIOS.navigationPath,
    })
  }, [])

  return <PortfoliosDataGrid />
}

export default PortfoliosIndex
